import { useApi } from "./useApi.ts";
import { ReturnRequest } from "../pages/returnRequest/types.ts";
import { saveAs } from "file-saver";

const API_BASE = process.env.REACT_APP_API_BASE as string;   // Vite 예시

export const useReturnRequestApi = () => {
    const { apiFetch } = useApi()

    const insertReturnRequest = async (form: ReturnRequest) => {
        const res = await apiFetch(`${API_BASE}/return-request/item/insert`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        if (!res.ok) throw new Error("server " + res.status);
        return res.blob();
      };

    const updateReturnRequest = async (form: ReturnRequest) => {
        const res = await apiFetch(`${API_BASE}/return-request/item/${form.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        if (!res.ok) throw new Error("server " + res.status);
        return res.blob();
      }

    const deleteReturnRequest = async (id: String) => {
        const res = await apiFetch(`${API_BASE}/return-request/item/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
        });

        if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || "삭제 실패");
        }

        const data = await res.json();
        console.log("삭제 결과:", data);
        return data
    }

    // 데이터 로딩
    const getAllReturnRequest = async () => {
        const res = await apiFetch(`${API_BASE}/return-request/item/get`);
        const json = await res.json();
        return json
    };

    const downloadPdf = async (form: ReturnRequest) => {
        const res = await apiFetch(`${API_BASE}/return-request/download/pdf`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        if (!res.ok) throw new Error(`server ${res.status}`);
        const blob = await res.blob();
        saveAs(blob, `회수요청서_${form.companyName}.pdf`);
      };

    return {
        insertReturnRequest,
        updateReturnRequest,
        deleteReturnRequest,
        getAllReturnRequest,
        downloadPdf
    }
}
